module.exports = __webpack_public_path__ + "img/epgEnabled.998ffb.svg";